
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'calendar': {
    width: 20,
    height: 20,
    viewBox: '0 0 17 20',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M3 0V2H2C0.898438 2 0 2.89844 0 4V18C0 19.1016 0.898438 20 2 20H16C17.1016 20 18 19.1016 18 18V4C18 2.89844 17.1016 2 16 2H15V0H13V2H5V0H3ZM2 7H16V18H2V7ZM9 11V16H14V11H9Z"/>'
  }
})
